/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locationnameoptional2Inputs */

const en_locationnameoptional2 = /** @type {(inputs: Locationnameoptional2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location Name (Optional)`)
};

const de_locationnameoptional2 = /** @type {(inputs: Locationnameoptional2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Ortes (optional)`)
};

/**
* | output |
* | --- |
* | "Location Name (Optional)" |
*
* @param {Locationnameoptional2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const locationnameoptional2 = /** @type {((inputs?: Locationnameoptional2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locationnameoptional2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locationnameoptional2(inputs)
	return de_locationnameoptional2(inputs)
});
export { locationnameoptional2 as "locationNameOptional" }